// removed by extract-text-webpack-plugin
module.exports = {"ant-modal-wrap":"ant-modal-wrap","push-modal-wrap":"push-modal-wrap","push-modal":"push-modal"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/pgs/ReportDetail/pushModal.scss
// module id = 932
// module chunks = 0